export const INVALID_COMPANY_INPUT = 101
export const INVALID_FIRST_NAME_INPUT = 102
export const INVALID_LAST_NAME_INPUT = 103
export const INVALID_PHONE_NUMBER_INPUT = 104
export const INVALID_NIP_INPUT = 105
export const INVALID_CITY_INPUT = 106
export const INVALID_STREET_INPUT = 107
export const INVALID_POSTAL_CODE_INPUT = 108
export const INVALID_EMAIL_INPUT = 109
